import '@/common';
import { createSliderWidget } from '@/widgets/SliderWidget';
import { createLinksListWidget } from '@/widgets/LinksListWidget';

createSliderWidget(document.querySelector('#slider-widget')!);
createLinksListWidget(document.querySelector('#links-list-widget')!);
